<template>

  <v-card>

    <!-- barra y botonera del paso -->
    <v-toolbar color="white" flat>
      <v-btn icon light>
        <v-icon color="grey darken-2">mdi-account-group</v-icon>
      </v-btn>
      <v-toolbar-title class="grey--text text--darken-4">
        {{ $t('datosPresupuesto') }}
        <p class="caption">{{ $t('datosCabeceraPresupuesto') }}</p>
      </v-toolbar-title>
      <div v-show="dShowLoading" id="loading" style="margin-left:50px;margin-top:-10px;z-index:99999">
        <div style="display: inline-block;">
          <cube-spin class="loadingStyle"></cube-spin>
        </div>
        <div style="display: inline-block;color:#43a047;margin-left:10px;margin-top:-50px">
          <span class="caption">{{ $t('procesando') }}...</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1  white--text" value="volver" @click="fVolver()">
        <v-icon>mdi-arrow-left</v-icon>
        <span>{{ $t('volver') }}</span>
      </v-btn>
      <v-btn color="green darken-1  white--text" value="continuar" @click="fGuardaContinuar()">
        <span>{{ $t('continuar') }}</span>
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- formulario con los datos -->
    <v-card-text>
      <v-form v-model="dValidacionPaso2" ref="form" lazy-validation>
        <v-container fluid>
          <v-layout row wrap>

            <v-flex xs4>
              <v-text-field color="green darken-1" id="1" :label="$t('referencia')"
                v-model="dPresupuestoAsistentePaso2.refPedido"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <v-menu ref="fechaCreacion" v-model="dFechaCreacionMenu" lazy transition="scale-transition" offset-y
                full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                <v-text-field clearable v-model="dFechaCreacionDateString" required color="data-colorcorp1"
                  slot="activator" :label="$t('fechaCreacion')" append-icon="event" readonly
                  :rules="[rules.checkCampoRequerido]"></v-text-field>
                <v-date-picker v-model="dFechaCreacionDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaCreacion.save(dFechaCreacionDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 px-3>
              <v-menu ref="fechaVigencia" v-model="dFechaVigenciaMenu" lazy transition="scale-transition" offset-y
                full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                <v-text-field clearable v-model="dFechaVigenciaDateString" required color="data-colorcorp1"
                  slot="activator" :label="$t('fechaVigencia')" append-icon="event" readonly
                  :rules="[rules.checkCampoRequerido, rules.checkfechaVigencia]"></v-text-field>
                <v-date-picker v-model="dFechaVigenciaDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaVigencia.save(dFechaVigenciaDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4>
              <v-menu ref="plazoEntrega" v-model="dPlazoEntregaMenu" lazy transition="scale-transition" offset-y
                full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                <v-text-field clearable v-model="dPlazoEntregaDateString" required color="data-colorcorp1"
                  slot="activator" :label="$t('plazoEntrega')" append-icon="event" readonly
                  :rules="[rules.checkPlazoEntrega]"></v-text-field>
                <v-date-picker v-model="dPlazoEntregaDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.plazoEntrega.save(dPlazoEntregaDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <v-select color="green darken-1" :label="$t('formaPago')" autocomplete item-text="formaPagoNombre"
                item-value="formaPago" :items="dItemsFormaPago" required :rules="[rules.checkCampoRequerido]"
                v-model="dSelectFormaPago"></v-select>
            </v-flex>
            <v-flex xs4 px-3>
              <v-select color="green darken-1" :label="$t('descuentoRappel')" autocomplete item-text="denomDto"
                item-value="tipoDescuento" :items="dItemsDescuentoRappel" required :rules="[rules.checkCampoRequerido]"
                v-model="dSelectDescuentoRappel"></v-select>
            </v-flex>
            <v-flex xs4>
              <v-select color="green darken-1" :label="$t('descuentoPP')" autocomplete item-text="denomDto"
                item-value="dto" :items="dItemsDescuentoPP" required :rules="[rules.checkCampoRequerido]"
                v-model="dSelectDescuentoPP"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field color="green darken-1" name="observaciones" :label="$t('observaciones')"
                v-model="dPresupuestoAsistentePaso2.observaciones" multi-line></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <div style="flex: 1 1 auto;"></div>

  </v-card>

</template>

<script>
import CubeSpin from 'vue-loading-spinner/src/components/Jumper'

// SERVICE
import SrvPres from '@/services/srv-presupuestos'

export default {
  name: 'ShpAsistentePaso2',
  props: {
    pPresupuestoAsistente: {
      type: Object,
      required: true
    },
    pEsNuevo: {
      type: Boolean,
      required: true
    }
  },
  components: {
    CubeSpin
  },
  data() {
    return {
      dShowLoading: !this.pEsNuevo,
      dLoadingFormaPago: false,
      dLoadingDescuentoRappel: false,
      dLoadingDescuentoPP: false,
      dPresupuestoAsistentePaso2: this.pPresupuestoAsistente,
      dDateForma: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dValidacionPaso2: true,
      dItemsFormaPago: [],
      dItemsDescuentoPP: [],
      dItemsDescuentoRappel: [],
      dSelectFormaPago: null,
      dSelectDescuentoPP: null,
      dSelectDescuentoRappel: null,
      dFechaCreacionMenu: false,
      dFechaCreacionDate: this.$moment(this.pPresupuestoAsistente.fechaCreacion, dDateForma.default).format(dDateForma.years),
      dFechaCreacionDateString: this.$moment(this.pPresupuestoAsistente.fechaCreacion, dDateForma.default).format(dDateForma.default),
      dFechaVigenciaMenu: false,
      dFechaVigenciaDate: this.$moment(this.pPresupuestoAsistente.vigencia, dDateForma.default).format(dDateForma.years),
      dFechaVigenciaDateString: this.$moment(this.pPresupuestoAsistente.vigencia, dDateForma.default).format(dDateForma.default),
      dPlazoEntregaMenu: false,
      dPlazoEntregaDate: this.$moment(this.pPresupuestoAsistente.vigencia, dDateForma.default).format(dDateForma.years),
      dPlazoEntregaDateString: this.$moment(this.pPresupuestoAsistente.vigencia, dDateForma.default).format(dDateForma.default),
      rules: {
        /*
         * Regla para comprobar la forma de pago
         */
        checkCampoRequerido: (value) => {
          return ((value === undefined) || (value === null)) ? this.$t('campoRequerido') : true
        },
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechaVigencia: (value) => {
          if ((this.dFechaCreacionDateString !== undefined) && (this.dFechaVigenciaDateString !== undefined) &&
            (this.dFechaCreacionDateString !== null) && (this.dFechaVigenciaDateString !== null) &&
            (this.dFechaCreacionDateString !== '') && (this.dFechaVigenciaDateString !== '')) {
            const dFechaCreacionDate = this.$moment(this.dFechaCreacionDateString, dDateForma.default)
            const dFechaVigenciaDate = this.$moment(this.dFechaVigenciaDateString, dDateForma.default)
            return (dFechaCreacionDate <= dFechaVigenciaDate) ? true : this.$t('fechaVigenciaMayorFechaPedido')
          } else {
            return true
          }
        },
        /*
         * Regla para comprobar fecha de creacion
         */
        checkPlazoEntrega: (value) => {
          if ((this.dFechaCreacionDateString !== undefined) && (this.dPlazoEntregaDateString !== undefined) &&
            (this.dFechaCreacionDateString !== null) && (this.dPlazoEntregaDateString !== null) &&
            (this.dFechaCreacionDateString !== '') && (this.dPlazoEntregaDateString !== '')) {
            const dFechaCreacionDate = this.$moment(this.dFechaCreacionDateString, dDateForma.default)
            const dPlazoEntregaDate = this.$moment(this.dPlazoEntregaDateString, dDateForma.default)
            return (dFechaCreacionDate <= dPlazoEntregaDate) ? true : this.$t('plazoEntrgaMayorFechaPedido')
          } else {
            return true
          }
        }
      }
    }
  },
  watch: {
    /*
     * Espera el cambio de la forma de pago
     */
    dSelectFormaPago: {
      handler() {
        this.dPresupuestoAsistentePaso2.formaPago = this.dSelectFormaPago
      },
      deep: true
    },
    /*
     * Espera el cambio del descuento pp
     */
    dSelectDescuentoPP: {
      handler() {
        this.dPresupuestoAsistentePaso2.dtoPP = this.dSelectDescuentoPP
      },
      deep: true
    },
    /*
     * Espera el cambio del descuento Rappel
     */
    dSelectDescuentoRappel: {
      handler() {
        this.dPresupuestoAsistentePaso2.dtoRappel = this.dSelectDescuentoRappel
      },
      deep: true
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    dFechaCreacionDate: function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dFechaCreacionDateString = this.$moment(val, dDateForma.years).format(dDateForma.default)
        this.dPresupuestoAsistentePaso2.fechaCreacion = this.dFechaCreacionDateString
      }
    },
    /*
     * Espera el cambio de la fecha de Vigencia para cambiar el formato
     */
    dFechaVigenciaDate: function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dFechaVigenciaDateString = this.$moment(val, dDateForma.years).format(dDateForma.default)
        this.dPresupuestoAsistentePaso2.vigencia = this.dFechaVigenciaDateString
      }
    },
    /*
     * Espera el cambio de la fecha del plazo de entrega para cambiar el formato
     */
    dPlazoEntregaDate: function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dPlazoEntregaDateString = this.$moment(val, dDateForma.years).format(dDateForma.default)
        this.dPresupuestoAsistentePaso2.plazoEntrega = this.dPlazoEntregaDateString
      }
    }
  },
  methods: {
    fCargarDefault(presupuesto) {
      this.dShowLoading = true
      this.dLoadingFormaPago = false
      this.dLoadingDescuentoRappel = false
      this.dLoadingDescuentoPP = false
      this.dPresupuestoAsistentePaso2 = presupuesto
      this.fCargaDescuentoRappel()
      this.fCargaFormaPago()
      this.fCargaDescuentoPP()



      if ((this.dPresupuestoAsistentePaso2.fechaCreacion !== undefined && this.dPresupuestoAsistentePaso2.fechaCreacion !== '')) {
        this.dFechaCreacionDate = this.$moment(this.dPresupuestoAsistentePaso2.fechaCreacion, dDateForma.default).format(dDateForma.years)
        this.dFechaCreacionDateString = this.$moment(this.dPresupuestoAsistentePaso2.fechaCreacion, dDateForma.default).format(dDateForma.default)
      } else {
        this.dFechaCreacionDate = ''
        this.dFechaCreacionDateString = ''
      }
      if ((this.dPresupuestoAsistentePaso2.vigencia !== undefined && this.dPresupuestoAsistentePaso2.vigencia !== '')) {
        this.dFechaVigenciaDate = this.$moment(this.dPresupuestoAsistentePaso2.vigencia, dDateForma.default).format(dDateForma.years)
        this.dFechaVigenciaDateString = this.$moment(this.dPresupuestoAsistentePaso2.vigencia, dDateForma.default).format(dDateForma.default)
      } else {
        this.dFechaVigenciaDate = ''
        this.dFechaVigenciaDateString = ''
      }

      if ((this.dPresupuestoAsistentePaso2.plazoEntrega !== null) && (this.dPresupuestoAsistentePaso2.plazoEntrega !== '')) {
        this.dPlazoEntregaDate = this.$moment(this.dPresupuestoAsistentePaso2.plazoEntrega, dDateForma.default).format(dDateForma.years)
        this.dPlazoEntregaDateString = this.$moment(this.dPresupuestoAsistentePaso2.plazoEntrega, dDateForma.default).format(dDateForma.default)
      } else {
        this.dPlazoEntregaDate = ''
        this.dPlazoEntregaDateString = ''
      }
      if (this.dLoadingFormaPago && this.dLoadingDescuentoRappel && this.dLoadingDescuentoPP) {
        this.dShowLoading = false
      }
    },
    /**
     * Metodo para guardar y continuar con el asistente
     */
    fGuardaContinuar() {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.dPresupuestoAsistentePaso2)
      }
    },
    /**
     * Metodo para volver al paso anterior del asistente
     */
    fVolver() {
      this.$emit('return')
    },
    /**
     * Metodo para cargar forma de pago ver donde coger el pais
     */
    fCargaFormaPago() {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.emprea,
        pais: this.$store.getters.getPais
      }
      SrvPres.getFormasPago(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.dLoadingFormaPago = true

          this.dItemsFormaPago = response.data.FORMAS_PAGO
          // obtiene forma de pago del presupuesto por defecto
          for (let i = 0; i < this.dItemsFormaPago.length; i++) {
            if (this.dPresupuestoAsistentePaso2.formaPago === this.dItemsFormaPago[i].formaPago) {
              this.dSelectFormaPago = this.dItemsFormaPago[i].formaPago
            }
          }
          if (this.dLoadingFormaPago && this.dLoadingDescuentoRappel && this.dLoadingDescuentoPP) {
            this.dShowLoading = false
          }

        } else {
          this.$emit('alert', '<b>carga formas de pago</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    },
    /**
     * Metodo para cargar descuentos de cabecera (rappel y pp) ver si se carga lo mismo o han de ser 2 ws
     */
    fCargaDescuentoPP() {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        fechaAplicacion: this.pPresupuestoAsistente.fechaCreacion,
        tipoDescuento: 'PP'
      }
      SrvPres.getListaDtos(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.dItemsDescuentoPP = response.data.DTOS
          // obtiene DescuentoPP del presupuesto por defecto
          for (let i = 0; i < this.dItemsDescuentoPP.length; i++) {
            if (this.dPresupuestoAsistentePaso2.tipoDtoPP === this.dItemsDescuentoPP[i].tipoDescuento) {
              this.dSelectDescuentoPP = this.dItemsDescuentoPP[i]
            }
          }
          this.dLoadingDescuentoPP = true
          if (this.dLoadingFormaPago && this.dLoadingDescuentoRappel && this.dLoadingDescuentoPP) {
            this.dShowLoading = false
          }
        } else {
          this.$emit('alert', '<b>carga descuentos pp</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    },
    /**
     * Metodo para cargar descuentos de cabecera (rappel y pp) ver si se carga lo mismo o han de ser 2 ws
     */
    fCargaDescuentoRappel() {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        fechaAplicacion: this.pPresupuestoAsistente.fechaCreacion,
        tipoDescuento: 'CAB'
      }
      SrvPres.getListaDtos(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.dItemsDescuentoRappel = response.data.DTOS
          // obtiene DescuentoPP del presupuesto por defecto
          for (let i = 0; i < this.dItemsDescuentoRappel.length; i++) {
            if (this.dPresupuestoAsistentePaso2.tipoDtoRappelFra === this.dItemsDescuentoRappel[i].tipoDescuento) {
              this.dSelectDescuentoRappel = this.dItemsDescuentoRappel[i]
            }
          }
          this.dLoadingDescuentoRappel = true
          if (this.dLoadingFormaPago && this.dLoadingDescuentoRappel && this.dLoadingDescuentoPP) {
            this.dShowLoading = false
          }

        } else {
          this.$emit('alert', '<b>carga descuentos rappel</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.loadingStyle.spinner>div[data-v-def4b4ac] {
  background-color: #43a047 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpAsistentePaso2.vue